<template>
  <!-- 文件列表 -->
  <section class="pack_box">
    <ax-panel :noTitle="true">
      <div class="header">
        <p class="date">{{ query.overtime_date }}</p>
        <p class="count">
          共 <span class="num">{{ query.overtime_person_count }}</span> 人
          <span class="cross">|</span>
          共 <span class="num">{{ query.qh_overtime_days }}</span> 天
        </p>
      </div>
    </ax-panel>
    <ax-panel :noTitle="true">
      <div class="content">
        <van-cell v-for="(item, index) in fileListData" :key="index" :title="item.name">
          <span class="desc">加班天数：</span><span class="days">{{ item.qh_overtime_days }}天</span>
        </van-cell>
      </div>
    </ax-panel>
  </section>
</template>

<script>
import completedObj from "@/assets/js/approval/completed.js";
import upcomingObj from "@/assets/js/approval/upComDetail.js";
import request from "@/utils/request";
export default {
  data() {
    return {
      query: this.$route.query,
      instanceId: this.$route.query.instanceId,
      fileKey: "",
      pageId: this.$route.query.pageId,
      pageObj: {},
      toast: null,
      fileListData: []
    };
  },
  watch: {
    $route() {
      this.getPageId();
      this.fetchDataByPageId();
    }
  },
  created() {
    console.log(this.$route.query);
    this.toast = this.$toast.loading({
      mask: false,
      message: "加载中...",
      duration: 0
    });
    this.getPageId();
    this.fetchDataByPageId();
  },
  methods: {
    // 获取pageId
    getPageId() {
      this.instanceId = this.$route.query.instanceId;
      this.pageId = this.$route.query.pageId;
      this.pageObj = completedObj[this.pageId] || upcomingObj[this.pageId];
      this.fileKey = this.pageObj.fileKey;
      this.$setIosTitle("法定加班申请明细");
    },
    // 根绝pageId 获取数据
    fetchDataByPageId() {
      if (!this.pageObj) {
        this.showResult = true;
        return;
      }
      let options = {
        url: '/treasure/ehr/statutoryOvertime/GetOvertimeDetail',
        method: this.pageObj.method
      };

      let body = {
        ...this.$route.query
      };
      delete body.pageId;
      delete body.instanceId;

      // this.pageObj.data.forEach(item => {
      //   body[item[0]] = this[item[1]];
      // });
      if (this.pageObj.method === "get") {
        options.params = body;
      } else {
        options.data = body;
      }
      request(options)
        .then(({ data }) => {
          if (data.code === 200) {
            this.showResult = false;
            this.fileListData = data.data;
            console.log(data.data);
          } else {
            this.showResult = true;
          }
        })
        .catch(e => {
          this.showResult = false;
          this.text = "暂无数据";
        })
        .finally(_ => {
          this.text = "暂无数据";
          this.toast.clear();
        });
    }
  },
  beforeDestroy() {
    this.toast && this.toast.clear();
  }
};
</script>

<style lang="scss" scoped>
.header {
  padding: 0.4rem;
  display: flex;
  width: 343px;
  height: 30px;
  justify-content: space-between;
  align-items: center;

  .date {
    color: #657083;
    /* F16-Regular */
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    /* 150% */
  }

  .count {
    color: #1D2531;
    /* F16-Regular */
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;

    /* 150% */
    .num {
      color: #006BFF;
    }

    .cross {
      color: #E1E7ED;
    }
  }
}

.content {
  min-height: 90vh;
  color: #1D2531;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  .desc {
    color: #657083
  }
  .days{
    width: 40px;
    text-align: right;
  }
}

.no-data {
  color: #888;
  text-align: center;
  padding: 100px 0;
}

.van-cell .van-cell__value {
  text-align: right;
}

.van-cell__title {
  color: #1D2531;

  /* F16-Regular */
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  /* 150% */
}

.van-cell {
  border-bottom: 1px dashed $border-color;
}
</style>
